import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function modificarmetadatosprincipalesneo (payload = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getNotificationstatus)
      }, 500)
    })
  } else {
    const req = {
      url: '/api/NEO/modificarmetadatosprincipalesneo',
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload,
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { modificarmetadatosprincipalesneo }
